import { useRouter } from 'next/router'

import { useAppSelector } from '~/redux/hooks'
import useCurrentUser from '~/hooks/useCurrentUser'

import ROUTES from '~/shared/constants/routes.const'
import { isAuthenticated } from '~/auth/slices/auth.slice'
import useSubscriptionApplicableForUser from '~/hooks/useSubscriptionNeededForUser'
import { selectHomebaseIsOpen } from '~/redux/slices/homebase'
import { selectShowSubscriptionActivityModal } from '~/redux/slices/modals'
import { useHasPremiumAccess } from '~/redux/utils/subscription'

const routesWithoutSubscriptionBanner: string[] = [
  ROUTES.ONBOARDING,
  ROUTES.DASHBOARD,
  ROUTES.GAMES,
  ROUTES.MATH_VAULT,
  ROUTES.SUBSCRIPTION_PAGE,
  ROUTES.SUBSCRIPTION_CHECKOUT_COMPLETE,
  ROUTES.SUBSCRIPTION_UPGRADE_COMPLETE,
  ROUTES.SUBSCRIPTION_CHECKOUT_PAYMENT,
  ROUTES.SUBSCRIPTION_CHECKOUT_LOGIN,
  ROUTES.SUBSCRIPTION_CHECKOUT_SIGNUP,
  ROUTES.SESSION_PAGE,
  ROUTES.FACEBOOK_CALLBACK,
  ROUTES.ADYEN_CALLBACK_PAGE,
  ROUTES.VIPPS_CALLBACK_PAGE,
  ROUTES.CAMPAIGNS,
  ROUTES.FAMILY_SWITCH_PROFILE,
  ROUTES.PROFILES,
  ROUTES.FAMILY_ADMIN_PANEL,
  ROUTES.FAMILY_ACCEPT_INVITE,
  ROUTES.START,
]

export default function useShowSubscriptionBanner(): boolean {
  const subscriptionApplicableForUser = useSubscriptionApplicableForUser()
  const authenticated = useAppSelector(isAuthenticated)
  const isSubscriptionModalOpen = useAppSelector(selectShowSubscriptionActivityModal)
  const user = useCurrentUser()
  const hasFullAccess = useHasPremiumAccess()

  const router = useRouter()
  const pathname = router.pathname

  const pageHasSubscriptionBanner = !routesWithoutSubscriptionBanner.some((route) => pathname.startsWith(route))

  const homebaseIsOpen = useAppSelector(selectHomebaseIsOpen)

  return (
    authenticated &&
    Boolean(user) &&
    subscriptionApplicableForUser &&
    pageHasSubscriptionBanner &&
    !homebaseIsOpen &&
    !isSubscriptionModalOpen &&
    !hasFullAccess
  )
}
